var map = {
	"./customerListIcon.svg": 2979,
	"./customersIcon.svg": 289,
	"./orderHistoryIcon.svg": 3169,
	"./orderInsightsIcon.svg": 8261,
	"./orderTrackerIcon.svg": 3172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;